module.exports = __webpack_public_path__ + "static/media/zkamil-system-architekt.25ed2762.png";